<script lang="ts">import Text from '../Text/Text.svelte';
// prettier-ignore
const { as = 'p', variant = 'regular', class: className = '', value = '', 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
children: _children = undefined, // placeholder variable added to avoid including in the ...rest params
...rest } = $props();
const mappedVariant = {
    regular: '50-r',
    bold: '50',
};
</script>

<Text
  {...rest}
  class="DisclaimerText DisclaimerText--{variant} {className}"
  {as}
  variant={mappedVariant[variant ?? 'regular']}
  {value}
/>

<style>@layer design-system-components.pwds {
  :global(.DisclaimerText) :global(a) {
    font-weight: inherit;
    text-decoration: underline;
    text-underline-offset: 0.2em;
  }
  :global(.DisclaimerText) :global(a), :global(.DisclaimerText) :global(a:hover), :global(.DisclaimerText) :global(a:focus), :global(.DisclaimerText) :global(a:active) {
    color: inherit;
  }
}</style>
